import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: "",
  remoteConfig: {},
  processing: false
};

const remoteConfigSlice = createSlice({
  name: "remoteConfigSlice",
  initialState: initialState,
  reducers: {
    fetchRemoteConfig: () => {
    },
    updateRemoteConfig: () => {
    },
    setLoading: (state) => {
      state.loading = true;
      state.success = false;
      state.error = "";
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    setProcessing: (state, action) => {
      state.processing = action.payload ?? true;
    },
    setRemoteConfig: (state, action) => {
      state.remoteConfig = action.payload;
      state.loading = false;
      state.processing = false;
    }
  }
});

export const {
  setLoading,
  setError,
  setProcessing,
  setRemoteConfig,
  fetchRemoteConfig,
  updateRemoteConfig
} = remoteConfigSlice.actions;
export default remoteConfigSlice.reducer;
